import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
      </div>
    );
  }
  return user ? <Dashboard /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <Gate />
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
